import React, { Component, Fragment } from "react";
import { legacy_connect as connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActionCreator } from "actions";
import { Dropdown } from "component/menu";
import { TableList } from "component/list";
import { FilterList } from "component/list";
import * as queryString from "query-string";
import { currencyFormatter } from "utils/currencyHelper";

import "containers/GamesRoundHistory/styles.scss";

import { ReactComponent as SortArrowDown } from "assets/icons/sort-arrow-down.svg";
import { ReactComponent as SortArrowUp } from "assets/icons/sort-arrow-up.svg";
import { withTranslation } from "react-i18next";
import { isEqual } from "lodash";
import ScrollDirectionTracker from "utils/ScrollDirectionTracker";

class RoundHistoryPerGame extends Component {
  constructor(props) {
    super(props);
    this.fetchList = this._fetchList.bind(this);
    this.fetchFilters = this._fetchFilters.bind(this);
    this.fetchAvailableMonths = this._fetchAvailableMonths.bind(this);
    this.applyWalletMonth = this._applyWalletMonth.bind(this);
    this.onSort = this._onSort.bind(this);
    this.onRowClick = this._onRowClick.bind(this);
    this.state = {
      availableMonths: null,
      selectedMonth: null,
      selectedMonthId: null,
      selectedMonthIndex: null,
      isLoading: false,
      isLoadingNext: false,
      gameRoundHistory: null,
      listComplete: null,
      isValidMonth: false,
      filter: null,
      selectedFilterIndex: null,
      isNavHidden: false,
      pendingScrollReset: false,
      sort: {
        orderBy: "DESC",
        sortBy: "lastPlayed",
      },
    };

    this.scrollTracker = new ScrollDirectionTracker({
      scrollContainerSelector: ".history",
      threshold: 8,
      topOffset: 20,
      onChange: (isHidden) => this.setState({ isNavHidden: isHidden }),
    });
  }

  _fetchAvailableMonths() {
    this.props
      .fetchGameHistoryAvailableMonths(
        this.props.gamesRoundHistoryAvailableMonthsLink,
      )
      .then((response) => {
        let initialMonthIndex = 0;
        if (this.props.historyMonthId && response) {
          const historyMonthIndex = response.findIndex(
            (month) => month.get("id") === this.props.historyMonthId,
          );
          if (historyMonthIndex !== -1) {
            initialMonthIndex = historyMonthIndex;
          }
        }
        let defaultMonth = response.get(0);
        if (defaultMonth) {
          this.setState({
            availableMonths: response,
            month: defaultMonth.get("id"),
            selectedMonth: defaultMonth.get("name"),
          });
        }

        this.props.setGameHistoryAvailableMonths(response);
        this.setState({
          availableMonths: response,
          selectedMonthIndex: response.size === 0 ? null : initialMonthIndex,
          filter: response.size === 0 ? [] : null,
        });
      });
  }

  _fetchFilters() {
    this.setState({
      filter: null,
      selectedFilterIndex: null,
    });
    let selectedMonth = this.state.availableMonths.get(
      this.state.selectedMonthIndex,
    );

    let params = {
      month: selectedMonth ? selectedMonth.get("id") : null,
    };

    this.props
      .fetchBetHistoryFilter(this.props.filterLink, params)
      .then((response) => {
        this.props.setBetHistoryFilter(response);
        this.setState({
          filter: response,
        });
      });
  }

  _fetchList(page) {
    if (!page) {
      this.setState({
        gameRoundHistory: null,
      });
    }

    if (
      (this.state.availableMonths && this.state.availableMonths.size === 0) ||
      (this.state.gameRoundHistory &&
        page > this.state.gameRoundHistory.get("totalPages"))
    ) {
      this.setState({
        listComplete: true,
      });
      return;
    }

    this.setState({
      isLoading: true,
      listComplete: false,
    });

    let selectedMonth = this.state.availableMonths.get(
      this.state.selectedMonthIndex === null
        ? 0
        : this.state.selectedMonthIndex,
    );

    let params = {
      month: selectedMonth && selectedMonth.get("id"),
      page: page,
      orderBy: this.state.sort.orderBy,
      sortBy: this.state.sort.sortBy,
    };

    if (this.state.selectedFilterIndex !== null) {
      let selectedFilter = this.state.filter.get(
        this.state.selectedFilterIndex,
      );
      params.status = selectedFilter.get("id");
    }

    this.props
      .fetchGameRoundHistory(this.props.gamesRoundHistoryLink, params)
      .then((response) => {
        let newgameRoundHistory = response;

        if (this.state.gameRoundHistory) {
          newgameRoundHistory = newgameRoundHistory.setIn(
            ["items"],
            this.state.gameRoundHistory
              .get("items")
              .concat(response.getIn(["items"])),
          );
        }

        this.props.setGameRoundHistory(newgameRoundHistory);
        this.setState({
          gameRoundHistory: newgameRoundHistory,
          isLoading: false,
        });
      });
  }

  _onSort(value) {
    let orderBy;

    if (value !== this.state.sort.sortBy) orderBy = "DESC";
    else if (this.state.sort.orderBy === "DESC") orderBy = "ASC";
    else if (this.state.sort.orderBy === "ASC") orderBy = "DESC";

    let newSort = {
      sortBy: value,
      orderBy,
    };

    this.setState({
      sort: newSort,
    });
  }

  componentDidMount() {
    if (this.props.gamesRoundHistoryAvailableMonthsLink) {
      this.fetchAvailableMonths();
    }
    this.scrollTracker.start();
  }

  componentDidUpdate(prevProps, prevState, snapShot) {
    if (
      !isEqual(
        prevProps.gamesRoundHistoryAvailableMonthsLink,
        this.props.gamesRoundHistoryAvailableMonthsLink,
      ) &&
      this.props.gamesRoundHistoryAvailableMonthsLink
    ) {
      this.fetchAvailableMonths();
    }

    if (
      !isEqual(prevState.availableMonths, this.state.availableMonths) &&
      this.state.availableMonths.size === 0
    ) {
      this.setState({
        listComplete: true,
      });
    }

    if (
      prevState.selectedMonthIndex !== this.state.selectedMonthIndex &&
      this.state.selectedMonthIndex !== null
    ) {
      this.fetchFilters();
      this.fetchList();
    }

    if (prevState.sort !== this.state.sort) {
      this.fetchList();
    }

    if (prevState.selectedFilterIndex !== this.state.selectedFilterIndex) {
      this.fetchList();
    }

    if (this.state.pendingScrollReset && !prevState.pendingScrollReset) {
      this.setState({ pendingScrollReset: false });
      requestAnimationFrame(() => {
        const historyContainer = document.querySelector(".history");
        if (historyContainer) {
          try {
            historyContainer.scrollTo({ top: 0, behavior: "smooth" });
          } catch (err) {
            historyContainer.scrollTop = 0;
          }
        }
      });
    }
  }

  componentWillUnmount() {
    this.scrollTracker.stop();
  }

  renderGameName(value) {
    let imgSrc = `${value.images.logoSquareUrl.replace(
      "width=90",
      "width=56",
    )}&theme=dark`;
    return (
      <div className="row game">
        <div className="col col-auto">
          <img src={imgSrc} alt={value.name} data-testid="game-icon" />
        </div>
        <div className="col d-flex align-items-center nopadding">
          <div>
            <div className="game-name" data-testid="game-title">
              {value.name}
            </div>
            <div className="provider" data-testid="game-provider-name">
              {value.provider.name}
            </div>
          </div>
        </div>
      </div>
    );
  }

  setLabel(id) {
    let { t } = this.props;
    try {
      switch (id) {
        case "lastPlayed":
          let AArrow =
            this.state.sort.orderBy === "DESC" ? SortArrowDown : SortArrowUp;
          return (
            <span
              className={`label-with-sort ${
                this.state.sort.sortBy === "lastPlayed" ? "selected" : ""
              }`}
            >
              {t(id)}
              {this.state.sort.sortBy === "lastPlayed" && (
                <div className="arrow nopadding d-none align-items-center">
                  <AArrow />
                </div>
              )}
            </span>
          );

        case "totalBet":
        case "totalPayout":
          return <div className="text-end">{t(id)}</div>;
        default:
          return <div>{t(id)}</div>;
      }
    } catch {
      return null;
    }
  }

  setValue(item) {
    switch (item.id) {
      case "game":
        return this.renderGameName(item.value);
      case "links":
        return JSON.stringify(item.value);
      case "totalPayout":
        return this.renderAmount(item);
      case "totalBet":
        return this.renderTotalBet(item);
      default:
        return item.value;
    }
  }

  renderTotalBet(item) {
    const { t } = this.props;

    let realValue;

    if (item.value.real) {
      realValue = currencyFormatter(item.value.real, {
        symbol: this.props.symbol,
        decimalPlaces: this.props.decimalPlaces,
      });
    }

    let freeValue;

    if (item.value.free) {
      freeValue = currencyFormatter(item.value.free, {
        symbol: this.props.symbol,
        decimalPlaces: this.props.decimalPlaces,
      });
    }

    return (
      <table className="total-bet-table">
        <tbody>
          {realValue && item.value.real > 0 && (
            <tr>
              <th data-testid="bet-type-label">{t("real")}:</th>
              <td>{realValue}</td>
            </tr>
          )}

          {freeValue && item.value.free > 0 && (
            <tr>
              <th data-testid="bet-type-label">{t("free")}:</th>
              <td>{freeValue}</td>
            </tr>
          )}
        </tbody>
      </table>
    );
  }

  renderAmount(item) {
    let value = currencyFormatter(item.value, {
      symbol: this.props.symbol,
      decimalPlaces: this.props.decimalPlaces,
    });

    return <div className="text-end">{value}</div>;
  }

  renderHeaderSkeleton(key) {
    switch (key) {
      case 6:
      case 7:
        return (
          <th key={key} className="text-end">
            <span className="dummy">loading</span>
          </th>
        );
      default:
        return (
          <th key={key}>
            <span className="dummy">loading</span>
          </th>
        );
    }
  }
  renderSkeleton(key) {
    switch (key) {
      case 0:
        return (
          <td key={key}>
            <span className="dummy">loading</span>
            <br />
            <span className="dummy">loading</span>
          </td>
        );
      case 1:
        return (
          <td key={key}>
            <span className="dummy">XXXXXXXXXXXXXXXXXXXXX</span>
          </td>
        );
      case 3:
        return (
          <td key={key}>
            <div className="row game">
              <div className="col col-auto">
                <span className="dummy">
                  <span className="dummy-image">loading</span>
                </span>
              </div>
              <div className="col d-flex align-items-center nopadding">
                <div>
                  <div className="game-name">
                    <span className="dummy">loading</span>
                  </div>
                  <div className="provider">
                    <span className="dummy">loading</span>
                  </div>
                </div>
              </div>
            </div>
          </td>
        );
      case 6:
      case 7:
        return (
          <td key={key} className="text-end">
            <span className="dummy">loading</span>
          </td>
        );
      default:
        return (
          <td key={key} className="text-end">
            <span className="dummy">loading</span>
          </td>
        );
    }
  }

  _applyWalletMonth() {
    this.setState({ isValidMonth: false });
  }

  handleMonthChange = (monthId, month, index) => {
    this.setState({
      selectedMonth: month,
      selectedMonthId: monthId,
      selectedMonthIndex: index,
      pendingScrollReset: true,
    });
    this.props.setHistoryMonth(month, monthId);
  };

  _onRowClick(item) {
    let link;
    let itemEncrypt = btoa(encodeURIComponent(JSON.stringify(item.toJSON())));

    try {
      link = item
        .get("links")
        .find((link) => link.get("rel") === "round-history-per-game.links");
    } catch (err) {}

    if (!link) return;

    let params = {
      modalRel: link.get("rel"),
      item: itemEncrypt,
    };

    let historyMonth = this.props.historyMonth || this.state.selectedMonth;
    let historyMonthId =
      this.props.historyMonthId || this.state.selectedMonthId;

    if (historyMonth && historyMonthId) {
      params.historyMonth = historyMonth;
      params.historyMonthId = historyMonthId;
    }

    let newLoc = `${this.props.location.pathname}?${queryString.stringify(
      params,
    )}`;

    this.props.navigateTo(newLoc);
  }

  render() {
    const { t } = this.props;
    const { isNavHidden } = this.state;

    return (
      <div className={`game-round-history ${isNavHidden ? "nav-hidden" : ""}`}>
        <FilterList
          list={this.state.filter}
          selectedIndex={this.state.selectedFilterIndex}
          skeletonCount={3}
          itemTestId="status-tab"
          handleChange={(index) => {
            this.setState({
              selectedFilterIndex:
                index === this.state.selectedFilterIndex ? null : index,
            });
          }}
        />
        <div
          data-testid="header-sub-title"
          className={`header-sub-title ${
            this.state.filter && this.state.filter.size > 1 ? "with-filter" : ""
          } ${isNavHidden ? "nav-hidden" : ""}`}
        >
          {this.state.availableMonths &&
            this.state.availableMonths.size > 0 && (
              <Fragment>
                <span data-testid="games-count-text">
                  {this.state.gameRoundHistory &&
                    `${this.state.gameRoundHistory.get("totalCount")} ${t(
                      "gamesIn",
                    )}`}
                  {!this.state.gameRoundHistory && (
                    <span className="dummy">loading loading</span>
                  )}
                </span>
                <span className="dropdown-container">
                  <Dropdown
                    data-testid="month-dropdown"
                    availableMonths={this.state.availableMonths}
                    selectedMonth={this.state.availableMonths.getIn([
                      this.state.selectedMonthIndex,
                      "name",
                    ])}
                    handleChange={this.handleMonthChange}
                  />
                </span>
              </Fragment>
            )}
          {!this.state.availableMonths && (
            <span className="dummy">loading loading</span>
          )}
        </div>
        <TableList
          list={this.state.gameRoundHistory}
          rowTestId="history-row"
          columnTestIds={{
            game: "game",
            lastPlayed: "last-played",
            totalRounds: "total-rounds",
            totalBet: "total-bet",
            totalPayout: "total-payout",
          }}
          initiated={
            this.state.availableMonths && this.props.gamesRoundHistoryLink
              ? true
              : false
          }
          isLoading={this.state.isLoading}
          listComplete={this.state.listComplete}
          onSort={this.onSort}
          onReachEnd={() => {
            let page = this.state.gameRoundHistory
              ? this.state.gameRoundHistory.get("page") + 1
              : null;
            this.fetchList(page);
          }}
          setLabel={(id) => {
            return this.setLabel(id);
          }}
          setValue={(item) => {
            return this.setValue(item);
          }}
          onRowClick={(item) => {
            this.onRowClick(item);
          }}
          setSkeleton={(key) => {
            return this.renderSkeleton(key);
          }}
          setHeaderSkeleton={(key) => {
            return this.renderHeaderSkeleton(key);
          }}
          totalColumn={9}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const sessionId = state.security.get("sessionId");
  const { modalRel } = queryString.parse(
    (ownProps.location && ownProps.location.search) || window.location.search,
  );

  if (
    !sessionId ||
    (modalRel !== "games-round-history" &&
      modalRel !== "games-round-history.links") ||
    !modalRel
  ) {
    return {};
  }
  let gamesRoundHistoryLink;
  try {
    gamesRoundHistoryLink = state.historyLinks.find((link) => {
      return link.get("rel") === "games-round-history";
    });
  } catch (err) {}

  let gamesRoundHistoryAvailableMonthsLink;
  try {
    gamesRoundHistoryAvailableMonthsLink = gamesRoundHistoryLink
      .get("links")
      .find((link) => {
        return link.get("rel") === "games-round-history.available-months";
      });
  } catch (err) {}

  let filterLink;
  try {
    filterLink = gamesRoundHistoryLink.get("links").find((link) => {
      return link.get("rel") === "games-round-history.statuses";
    });
  } catch (err) {}

  return {
    gamesRoundHistoryLink,
    gamesRoundHistoryAvailableMonthsLink,
    filterLink,
    decimalPlaces: state.links.get("decimalPlaces"),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return bindActionCreators(ActionCreator, dispatch);
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, stateProps, ownProps, {
    logout: () => dispatchProps.logout(),
    fetchGameHistoryAvailableMonths: (route) =>
      dispatchProps.fetchGameHistoryAvailableMonths(route),
    setGameHistoryAvailableMonths: (payload) =>
      dispatchProps.setGameHistoryAvailableMonths(payload),
    fetchGameRoundHistory: (route, params) =>
      dispatchProps.fetchGameRoundHistory(route, params),
    setGameRoundHistory: (payload) =>
      dispatchProps.setGameRoundHistory(payload),
    fetchBetHistoryFilter: (route, params) =>
      dispatchProps.fetchBetHistoryFilter(route, params),
    setBetHistoryFilter: (payload) =>
      dispatchProps.setBetHistoryFilter(payload),
  });
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(withTranslation("translation")(RoundHistoryPerGame));
